var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(-1454 -68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(1454 68)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "baseline-person-24px",
    transform: "translate(1463.693 75.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M15.138,15.138A5.569,5.569,0,1,0,9.569,9.569,5.567,5.567,0,0,0,15.138,15.138Zm0,2.784C11.42,17.922,4,19.787,4,23.491v2.784H26.275V23.491C26.275,19.787,18.855,17.922,15.138,17.922Z",
    fill: "none",
    stroke: "#262a68",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.af3c72ae998a3db3df89f1a94b5a05f3.svg";
export { ForwardRef as ReactComponent };